import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Accounts from "@/pages/Accounts";
import Transfer from "@/pages/Transfer";
import Cards from "@/pages/Cards";
import Loans from "@/pages/Loans";
import Crypto from "@/pages/Crypto";
import Transactions from "@/pages/Transactions";
import AdminMetrics from "@/pages/admin/AdminMetrics";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminLoans from "@/pages/admin/AdminLoans";

const CustomerWrap = ({ children }) => <AppShell mode="customer">{children}</AppShell>;
const AdminWrap = ({ children }) => <AppShell mode="admin">{children}</AppShell>;

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route path="/app" element={<ProtectedRoute><CustomerWrap><Dashboard /></CustomerWrap></ProtectedRoute>} />
            <Route path="/app/accounts" element={<ProtectedRoute><CustomerWrap><Accounts /></CustomerWrap></ProtectedRoute>} />
            <Route path="/app/transfer" element={<ProtectedRoute><CustomerWrap><Transfer /></CustomerWrap></ProtectedRoute>} />
            <Route path="/app/cards" element={<ProtectedRoute><CustomerWrap><Cards /></CustomerWrap></ProtectedRoute>} />
            <Route path="/app/loans" element={<ProtectedRoute><CustomerWrap><Loans /></CustomerWrap></ProtectedRoute>} />
            <Route path="/app/crypto" element={<ProtectedRoute><CustomerWrap><Crypto /></CustomerWrap></ProtectedRoute>} />
            <Route path="/app/transactions" element={<ProtectedRoute><CustomerWrap><Transactions /></CustomerWrap></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminWrap><AdminMetrics /></AdminWrap></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminWrap><AdminUsers /></AdminWrap></ProtectedRoute>} />
            <Route path="/admin/loans" element={<ProtectedRoute adminOnly><AdminWrap><AdminLoans /></AdminWrap></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
